import { apiPayment } from "api"
import fetchWithTimeout from "api/fetchWithTimeout"
import config from "lib/config"

const fetchDataWithRetries = async (url, options, retries = 3, delay = 1000) => {
  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      const response = await fetchWithTimeout(url, options)
      const data = await response.json()
      return data
    } catch (error) {
      console.warn(`Retrying (${attempt}/${retries}) for URL: ${url}`)
      // eslint-disable-next-line no-undef, no-async-promise-executor
      await new Promise((resolve) => setTimeout(resolve, delay))
    }
  }
}

export async function getPropsHomePage(accessToken) {
  let listIdSub = ""
  try {
    const { data, success } = await apiPayment.getMySub()
    if (success && data?.length > 0) {
      listIdSub = data?.map((sub) => sub?.package?.subs_id).join(",")
    } else {
      const response = await apiPayment.getHistoryTransaction({
        page_num: 1,
        page_size: 30,
        total: 0,
        transaction_type: 1
      })
      const filteredData = response?.data?.filter((item) => item?.expired_date)
      const firstItemArray = filteredData && filteredData.length > 0 ? [filteredData[0]] : []
      listIdSub = firstItemArray.map((sub) => sub?.subs_id).join(",")
    }
  } catch (error) {
    console.log({ message: error })
  }

  const endpoints = [
    { key: "screenblocks", url: `${config.BASE_API_URL}/publish/events/`, allowParam: true },
    { key: "slides", url: `${config.BASE_API_URL}/publish/slides/`, allowParam: false },
    { key: "leagues", url: `${config.BASE_API_URL}/publish/home/leagues/`, allowParam: false },
    { key: "backgrounds", url: `${config.BASE_API_URL}/publish/background/`, allowParam: false },
    { key: "recommends", url: `${config.BASE_API_URL}/publish/recommendationBlock`, allowParam: true }
  ]

  const resData = {
    screenblocks: [],
    slides: [],
    leagues: [],
    backgrounds: [],
    recommends: []
  }

  try {
    // console.log("khanhkaka listIdSub", listIdSub)
    const fetchPromises = endpoints.map(({ key, url, allowParam }) =>
      fetchDataWithRetries(url, {
        headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        timeout: 5000,
        params: accessToken && allowParam ? { package_ids: listIdSub } : {}
      })
        .then((data) => {
          if (data?.data?.length) resData[key] = data.data
        })
        .catch((error) => {
          console.error(`Error fetching ${key}:`, error)
        })
    )

    // eslint-disable-next-line no-undef, no-async-promise-executor
    await Promise.all(fetchPromises)
  } catch (error) {
    console.error("getPropsHomePage error:", error)
  }

  return resData
}
